//TODO: use UmeConfigUtils in all aplication
export default class UmeConfigUtils {
  static CUSTOMER_SERVICE_WHATSAPP = '+551140201960'
  static CUSTOMER_SERVICE_CENTER_PHONE_NUMBER = '08000312333'
}
